import { keyframes } from 'styled-components';

export const blue = '#0078D4';
export const red = '#e4433d';
export const green = '#39ac67';
export const yellow = '#faca15';

export const fadein = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export type alertAppearance = 'info' | 'success' | 'warning' | 'danger';
